export const InteractiveFormField = {
  countThemselvesVotes: "countThemselvesVotes",
  hiddenJudges: "hiddenJudges",
  hiddenAuthors: "hiddenAuthors",
} as const;
